import { type ObjectValuesUnionType } from '../../utils/typing';

export const AuthActionTypes = Object.freeze({
  RECEIVED_TOKEN: 'AUTH:RECEIVED_TOKEN',
  INVALIDATE_TOKEN: 'AUTH:INVALIDATE_TOKEN',
});
export type AuthActionType = ObjectValuesUnionType<typeof AuthActionTypes>;
